import { useEffect } from 'react'

export interface ScriptTag {
  src?: string
  innerHTML?: string
  type?: string
}

/** Appends script tags to <head> on mount and removes them on unmount. Pass a stable array - it runs once. */
export function useScripts(scripts: ScriptTag[]) {
  useEffect(() => {
    const elements = scripts.map((script) => {
      const element = document.createElement('script')
      if (script.type) element.type = script.type
      if (script.src) element.src = script.src
      if (script.innerHTML) element.text = script.innerHTML
      document.head.appendChild(element)
      return element
    })

    return () => elements.forEach((element) => element.remove())
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, [])
}
